import { render, staticRenderFns } from "./SafeChargeSuccess.vue?vue&type=template&id=36e9a24e&"
import script from "./SafeChargeSuccess.vue?vue&type=script&lang=js&"
export * from "./SafeChargeSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports